var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZvukColorLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 50,
    viewBox: "0 0 95 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zvuk"
  }, /*#__PURE__*/React.createElement("g", {
    id: "zvuk-color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_ru"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 20,
    cy: 24,
    r: 20,
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M23.5755 24.8972C21.936 24.8972 20.6024 26.3203 20.6024 28.0698C20.6024 28.0812 20.6027 28.0925 20.6032 28.1002C20.5958 28.3656 20.6307 29.2111 21.2462 30.3762C22.0529 31.9028 23.503 33.3351 25.5569 34.634C25.5968 34.6639 25.6423 34.6874 25.6916 34.7029C25.7359 34.7168 25.7813 34.7237 25.8266 34.7237C25.8744 34.7237 25.922 34.716 25.9671 34.7011C26.0206 34.682 26.0562 34.6634 26.0884 34.6407C28.1423 33.3418 29.5924 31.9095 30.3991 30.3828C31.0146 29.2178 31.0495 28.3723 31.0421 28.1067C31.0424 28.0992 31.0429 28.0878 31.0429 28.0765C31.0429 26.327 29.7091 24.9039 28.0696 24.9039C27.1885 24.9039 26.0884 25.4063 25.8259 26.5483C25.5569 25.3996 24.4568 24.8972 23.5755 24.8972Z",
    fill: "url(#paint0_linear_107_365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M21.5938 12.0611C21.4536 11.981 21.2798 11.9795 21.1383 12.0575C20.9968 12.1355 20.9094 12.2809 20.9094 12.4386V22.309C20.9094 22.4664 20.9968 22.612 21.1383 22.69C21.2079 22.7284 21.2853 22.7477 21.3627 22.7477C21.4427 22.7477 21.5226 22.7271 21.5938 22.6864L30.2065 17.7513C30.3443 17.6722 30.4288 17.5287 30.4288 17.3737C30.4288 17.2188 30.3443 17.0752 30.2065 16.9962L21.5938 12.0611Z",
    fill: "url(#paint1_linear_107_365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M17.5316 12.8652C17.5316 12.6585 17.417 12.4686 17.2335 12.3712C16.7375 12.1079 15.9719 12.6944 15.9719 13.4256V27.8409C13.0103 26.4213 9.54761 28.6009 9.54761 31.5478C9.54761 33.1069 10.5825 34.4166 12.9369 34.4166C15.2642 34.4166 17.5184 32.3239 17.5316 28.7376V12.8652Z",
    fill: "url(#paint2_linear_107_365)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M84.7052 20.2991H88.1453L87.4297 23.8067H88.4634L90.9493 20.2991H94.8865L90.9293 25.4541V25.4926L93.2957 30.2796H89.5771L87.9463 26.6169H86.873L86.137 30.2796H82.6968L84.7052 20.2991Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M72.3574 31.5589C72.954 31.5589 73.6701 31.4039 74.2067 30.551L74.5052 30.0856L72.0989 20.2991H75.6785L76.5136 25.241C76.6127 25.7835 76.6127 26.7139 76.6127 26.7139H76.6527C76.6527 26.7139 77.0107 25.842 77.2692 25.2991L79.5557 20.2991H83.4139L77.0107 31.3455C75.738 33.5357 73.9682 34.3496 72.5364 34.3496C71.6217 34.3496 70.6471 34.0782 69.8519 33.5742L71.3432 31.2489C71.6018 31.4424 72.0193 31.5589 72.3574 31.5589Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7645 20.2991H62.2764L60.2676 30.2796H65.9551C68.1225 30.2796 70.4094 29.1946 70.4094 27.1209C70.4094 26.3069 70.0514 25.4346 69.1767 25.1051V25.086C70.3699 24.5432 70.867 23.5158 70.867 22.6053C70.867 21.1325 69.6338 20.2991 67.7645 20.2991ZM66.2137 24.2332C66.8898 24.2332 67.4464 23.7098 67.4464 23.1088C67.4464 22.6828 67.1679 22.3728 66.5517 22.3728H65.299L64.921 24.2332H66.2137ZM65.637 28.1863C66.2932 28.1863 66.9693 27.6828 66.9693 26.9659C66.9693 26.5009 66.6708 26.1905 66.0546 26.1905H64.5234L64.1258 28.1863H65.637Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1_2",
    d: "M50.5249 26.2294C51.2405 27.0628 52.3347 27.5472 53.3484 27.5472C54.5021 27.5472 55.6353 26.9268 55.6353 25.7449C55.6353 25.0665 55.2177 24.6985 54.1836 24.6985H52.1352L52.6723 21.9849H54.4026C55.3768 21.9849 56.371 21.3069 56.371 20.2795C56.371 19.5821 55.9934 19.1361 54.9792 19.1361C54.2631 19.1361 53.3289 19.3496 51.9762 20.2795L50.7435 17.8187C52.4337 16.5199 54.3031 16.1904 55.5558 16.1904C58.0217 16.1904 60.0501 17.3338 60.0501 19.6595C60.0501 21.2294 59.0359 22.5278 57.5246 23.1283L57.5046 23.1672C58.4788 23.6131 59.1949 24.6015 59.1949 25.8804C59.1949 28.7486 56.2319 30.5124 53.3684 30.5124C51.4396 30.5124 49.5902 29.7175 48.5361 28.3997L50.5249 26.2294Z",
    fill: "#101010"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_365",
    x1: 14.7091,
    y1: 29.1771,
    x2: 24.4464,
    y2: 40.8566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_365",
    x1: 14.8422,
    y1: 18.8501,
    x2: 28.062,
    y2: 28.0357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99F6B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_107_365",
    x1: 9.54761,
    y1: 12.3071,
    x2: 9.54761,
    y2: 34.4166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZvukColorLight);
export default __webpack_public_path__ + "static/media/zvuk-color-light.3cffbacee97b889677e1d9a8d40151ff.svg";
export { ForwardRef as ReactComponent };